import React from 'react';
import DocumentTitle from 'react-document-title';
import {
  Box,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AsyncBox } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import useIntl from '../../hooks/useIntl';
import { useLeadManagement } from './hooks';
import Funnel from './Funnel';
import StageLeadsPanel from './StageLeadsPanel';
import messages from './messages';

const NAME = 'lead-management';

const LeadManagement = () => {
  const intl = useIntl();
  const {
    documentTitle,
    header,
    isPropertySelected,
    funnel,
    selectedStage,
    selectedStageKey,
    onSelectStage,
    leads,
    assign,
    activityActions,
  } = useLeadManagement();

  return (
    <DocumentTitle title={documentTitle}>
      <Box data-testid={NAME} sx={{ p: 3 }}>
        <Stack spacing={0.5} sx={{ mb: 3 }}>
          <Typography variant="titleLarge">{header}</Typography>
          {/* Only show the active-lead count once the funnel has resolved, so
              it never flashes "0 active leads" during load or on error. */}
          {isPropertySelected && !funnel.isLoading && !funnel.isError && (
            <Typography variant="bodyMedium" sx={{ color: 'text.secondary' }}>
              {intl.formatMessage(messages.subheader, { count: funnel.totalActive })}
            </Typography>
          )}
        </Stack>

        {!isPropertySelected ? (
          <Typography variant="bodyMedium" sx={{ color: 'text.secondary' }}>
            {intl.formatMessage(messages.selectPropertyPrompt)}
          </Typography>
        ) : (
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={3}
            sx={{ alignItems: 'flex-start' }}
          >
            <Box sx={{ flex: '1 1 auto', minWidth: 0, width: '100%' }}>
              <AsyncBox loading={funnel.isLoading}>
                {funnel.isError ? (
                  <Typography variant="bodyMedium" sx={{ color: 'error.main' }}>
                    {intl.formatMessage(messages.funnelError)}
                  </Typography>
                ) : funnel.isEmpty ? (
                  <Typography variant="bodyMedium" sx={{ color: 'text.secondary' }}>
                    {intl.formatMessage(messages.emptyFunnel)}
                  </Typography>
                ) : (
                  <Funnel
                    groupedStages={funnel.groupedStages}
                    maxCount={funnel.maxCount}
                    totalActive={funnel.totalActive}
                    selectedStageKey={selectedStageKey}
                    onSelectStage={onSelectStage}
                  />
                )}
              </AsyncBox>
            </Box>

            <Box sx={{ flex: '0 0 auto', width: { xs: '100%', md: 380 } }}>
              <StageLeadsPanel
                selectedStage={selectedStage}
                leads={leads}
                assign={assign}
                activityActions={activityActions}
              />
            </Box>
          </Stack>
        )}
      </Box>
    </DocumentTitle>
  );
};

export default LeadManagement;
